import {createApp} from 'vue';
import sendAnalyticsEvent from '../modules/sendAnalyticsEvent';

const VIDEO_LABEL = 'TV Campaign Video - Iframe';

const app = createApp({
    data() {
        return {
            showLogo: true,
            showFacade: true,
        };
    },
    methods: {
        ctaClick: function() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        playAdvert: function() {
            sendAnalyticsEvent('Video Engagement', 'Video Facade Click', VIDEO_LABEL);

            const video = this.$refs.tvAdvert as HTMLVideoElement | undefined;
            if (!video) return;

            const started = video.play();

            if (started) started.catch(() => undefined);
        },
        onAdvertPlaying: function() {
            this.showFacade = false;
            this.showLogo = false;
            sendAnalyticsEvent('Video Engagement', 'Video Playing', VIDEO_LABEL);
        },
        onAdvertPaused: function() {
            this.showLogo = true;
        },
        onAdvertEnded: function() {
            this.showLogo = true;
            sendAnalyticsEvent('Video Engagement', 'Video Ended', VIDEO_LABEL);
        },
    },
});

app.mount('#home-content');
